<footer class="full-height">
  <p>© 2017-{{currentYear}} Newforma, Inc.</p>
</footer>
